"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keys_1 = __importDefault(require("lodash/keys"));
/**
 * Formats an API endpoint with Query String
 * @param {string} endpoint
 * @param searchQuery
 * @returns {string}
 */
// to-do: define proper type for param
function formatURLWithQueryParam(endpoint, searchQuery) {
    // const esc = encodeURIComponent;
    const query = (0, keys_1.default)(searchQuery)
        .map((k) => `${k}=${searchQuery[k]}`)
        .join('&');
    return `${endpoint}?${query}`;
}
exports.default = formatURLWithQueryParam;
